export default "__VITE_ASSET__S0EDI6p4__"